'use strict';

var selectConfigCtrl = ['$uibModal', function ($uibModal) {
    var _this = this;

    _this.makeDinamic = function () {
        _this.element.isDinamic = true;
        _this.openConfig();
    }
    _this.makeStatic = function () {
        _this.element.isDinamic = false;
    }
    _this.openConfig = function () {
        
        var options = {
            animation: true,
            controller: require("../dinamic-select-config/dinamicSelectConfig"),
            templateUrl: 'dashboard-builder/dinamic-select-config/dinamicSelectConfig.html',
            controllerAs: 'ctrl',
            size: 'lg',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                element: function () {
                    return _this.element;
                }
            }
        };

        $uibModal.open(options);
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            isForValidator:'='
        },
        replace: true,
        controller: selectConfigCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/select-element/selectOptions.html'
    };
};